
  import { defineComponent } from "@nuxtjs/composition-api";

  export default defineComponent({
    name: "SplashPage",
    layout: "portal",

    head() {
      return {
        title: "Loadsure"
      };
    }
  });
